import React from "react";
import {
  Box, ContentCopyFilledIcon,
  ContentCutFilledIcon,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const IconMenuDense = () => {
  return (
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
            Dense menu
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
            For the menu that has long list and long text, you can use the dense prop to reduce the padding and text size.
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>

      <PreviewAndEditor
        language="js"
        title={"Dense Icon Menu"}
        value={"import {Box, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Typography,} from \"@mui/material\";\n" +
            "import {ContentCopy, ContentCut} from \"@mui/icons-material\";\n\n\n"+
            "<Paper sx={{ width: 320, maxWidth: \"100%\" }}>\n" +
            "          <MenuList dense>\n" +
            "            <MenuItem>\n" +
            "              <ListItemIcon>\n" +
            "                <ContentCut fontSize=\"small\" />\n" +
            "              </ListItemIcon>\n" +
            "              <ListItemText>Add space before paragraph</ListItemText>\n" +
            "              <Typography variant=\"body2\" color=\"text.secondary\">\n" +
            "                ⌘X\n" +
            "              </Typography>\n" +
            "            </MenuItem>\n" +
            "            <MenuItem>\n" +
            "              <ListItemIcon>\n" +
            "                <ContentCopy fontSize=\"small\" />\n" +
            "              </ListItemIcon>\n" +
            "              <ListItemText>Add space after paragraph</ListItemText>\n" +
            "              <Typography variant=\"body2\" color=\"text.secondary\">\n" +
            "                ⌘C\n" +
            "              </Typography>\n" +
            "            </MenuItem>\n" +
            "          </MenuList>\n" +
            "        </Paper>"}
      >
        <Paper sx={{ width: 320, maxWidth: "100%" }}>
          <MenuList dense>
            <MenuItem>
              <ListItemIcon>
                <ContentCutFilledIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Add space before paragraph</ListItemText>
              <Typography variant="body2" color="text.secondary">
                ⌘X
              </Typography>
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <ContentCopyFilledIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Add space after paragraph</ListItemText>
              <Typography variant="body2" color="text.secondary">
                ⌘C
              </Typography>
            </MenuItem>
          </MenuList>
        </Paper>
      </PreviewAndEditor>
    </Box>
      </Stack>
  );
};

export default IconMenuDense;
